import { Col, Form, Input, InputNumber, Radio, RadioChangeEvent, Row, Select, Switch } from 'antd';
import { useEffect, useRef, useState, } from 'react'
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import getList from '../../universal/getList';
import fetchApi from '../../../utils/api/fetchApi';
const { TextArea } = Input;




export default function BranchStoreFloorEdit(props: any) {
  const [form] = Form.useForm(); //form 
  const { data } = props;
  const [emailSupplierData, setEmailSupplierData] = useState<any>([])
  const ref = useRef<any>(undefined);
  const handleOk = (e: any) => {
    ref.current.handleOk();
  };
  const handleCancel = (e: any) => {


    ref.current.handleCancel();
  };
  /** 后端数据wmService */
  let wmService: any = "";
  let extendProps: WEUExtendPropsType = {
    ...props,
    form,
    apiId: 'branchStoreConfiguration'
  };

  useEffect(() => {
    if (ref.current) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      wmService = ref.current.wmService;
    }
    const fetchData = async () => {

      fetchApi.GET(wmService, {
        apiId: "emailSupplier",
        apiExtend: 'showList'
      }).then(res => {
        if (res.success) {
          console.log("res",res);
          
             setEmailSupplierData(res.data)
        }
      })
    }
    fetchData()
  }, [])

  return (
    <>
      <WebEditUniversal ref={ref} props={extendProps}></WebEditUniversal>
      <AntDraggableModal
        title={(data.type === 'NEW' ? '新增' : '编辑') + '门店配置'}
        open={true}
        okText='确定'
        cancelText='取消'
        onOk={handleOk}
        onCancel={handleCancel}
        closable={false}
        maskClosable={false}
        width={"75%"}
      >
        <Form
          form={form}
          name="Edit"
          onFinish={handleOk}
          onKeyDown={(e: any) => {
            if (e.key === 'Enter') {
              handleOk(e)
            }
          }}
        >
          <Row >
            <Col span={8}>
              <Form.Item
                label="id"
                name="id">
                <Input disabled />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="显示库存数"
                name="lessStockNum">
                <InputNumber min={0} />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="别名"
                name="alias">
                <Input />
              </Form.Item>
            </Col>

                <Col span={8}>
              <Form.Item
                label="购物车页面标题"
                name="cartTitle">
                <Input />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                label="副id"
                name="isCreateViceId"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="启用"
                  unCheckedChildren="关闭" />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                label="替换主订单id"
                name="isReplaceId"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="启用"
                  unCheckedChildren="关闭" />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                label="预结抬头"
                name="cateringCheckoutHead">
                <Input />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                label="订单前缀"
                name="prefixOrder">
                <Input />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="电话集合"
                name="phoneCollection">
                <TextArea
                  placeholder="电话集合"
                  autoSize={{ minRows: 2, maxRows: 6 }} />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="距离限制"
                name="isDistanceVerification"
                valuePropName="checked"
                initialValue={true}>
                < Switch checked={true}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="自动清理库存"
                name="isAoToClearInventory"
                valuePropName="checked"
                initialValue={true}>
                < Switch checked={true}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="结账单"
                name="isSettleBill"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="会员消费时自动出消费纸"
                name="membershipConsumptionAutoPaper"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="强制指定会员消费出默认打印机"
                name="forceConsumptionAutoPaper"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="会员支付全扣"
                name="isWxMembershipPayAll"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="积分抵扣现金"
                name="pointDeductionCash"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="购物车打印价格"
                name="printCartShowPrice"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="最大距离"
                name="maxDistance">
                <Input />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="自动接单"
                name="isAutocOrderReceiving"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="小程序营销地址"
                name="marketingUrl">
                <Input />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="不在销售时间显示"
                name="isNotDuringSalesShow"
                valuePropName="checked"
                initialValue={true}>
                < Switch checked={true}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="下单二次确认"
                name="secondaryConfirmationOrder"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="部分结账"
                name="isPartialCheckout"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="删菜出堂口单"
                name="isRefundMenu"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="扫码看菜谱加购物车"
                name="isMenuHeadScanningToCart"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="快闪"
                name="isFlash"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="使用会员充值地址"
                name="isRechargeCode"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="会员充值地址"
                name="rechargeCode">
                <Input />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="使用发票"
                name="isFaPiao"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="自助发票"
                name="selfServiceFaPiao"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="发票跟账单"
                name="faPiaoIsBill"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="销售方名称"
                name="sellerName">
                <Input />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="纳税人识别号"
                name="sellerTaxId">
                <Input />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="销售方地址"
                name="sellerAddress">
                <Input />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="销售方电话"
                name="sellerPhone">
                <Input />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="销售方开户行"
                name="sellerBankName">
                <Input />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="销售方银行账号"
                name="sellerBankAccountNumber">
                <Input />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="替换原logo图片地址"
                name="logoSrc"
                tooltip="注：如果没有内容，则使用品牌里设置的Logo图片">
                <Input />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="预订菜单底部图片"
                name="reserveMenuEnding"
                tooltip="注：如果没有内容，则使用品牌里设置的菜单底部图片">
                <Input />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="预订菜单Logo图片"
                name="reserveMenuLogo"
                tooltip="注：如果没有内容，则使用品牌里设置的Logo图片">
                <Input />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="预订菜单反色Logo图片"
                name="reserveMenuLogoInvert"
                tooltip="注：如果没有内容，则使用品牌里设置的Logo图片">
                <Input />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="支付页面地址"
                name="payBillUrl">
                <Input />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="获取指定时间的单价"
                name="monthsBack"
                tooltip="设置主配料时，可获取设定时间内的最新单价">
                <InputNumber min={3} max={36} addonAfter={"个月内"} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="邀请函页面入店指引"
                name="invitationLetterStoreEntryInstructionsUrl"
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="自动选中打印机"
                name="isAutoPrint"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="默认打印预结单"
                name="isAutoPrintCateringCheckoutDetailAccountsOrder"
                valuePropName="checked"
                initialValue={true}>
                < Switch checked={true}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="购物车加订单价格"
                name="printShoppingCartPriceOrder"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="反结账发送"
                name="reverseClosingSend"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="预结人数"
                name="mandatoryNumber"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="0时清台"
                name="isZeroCheckOut"
                valuePropName="checked"
                initialValue={true}>
                < Switch checked={true}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="扫房台码进订单页面"
                name="scanRoomCodeToOrder"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="扫预结码进小程序"
                name="scanCheckOutToWxMin"
                valuePropName="checked"
                initialValue={false}>
                < Switch checked={false}
                  checkedChildren="是"
                  unCheckedChildren="否" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="邮件供应商"
                name="emailSupplierId"
              >
                <Select
                  showSearch
                  placeholder="邮件供应商"
                  optionFilterProp="children"
                  filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                  {getList.generalEx(emailSupplierData, { itemName: "supplierName" })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </AntDraggableModal>

    </>
  )
}


